import styled from '@emotion/styled';
import FacebookIcon from '@ep/images/facebook.svg';
import LinkedInIcon from '@ep/images/linkedin.svg';
import TwitterIcon from '@ep/images/twitter.svg';
import theme from '@ep/theme';
import IosShareIcon from '@mui/icons-material/IosShare';
import React from 'react';
import Link from '../Link';

export interface SocialShareProps {
  pathname: string;
  alignRight?: boolean;
  darkBackground?: boolean;
  instanceAt?: string;
}

const Wrapper = styled.div<SocialShareProps>`
  @media (min-width: 1318px) {
    position: absolute;
    top: 7.5rem;
    ${({ alignRight }) => (alignRight ? `left: 1115px;` : 'left: -4.5rem;')};
    bottom: 7.5rem;
  }

  @media (max-width: 1317px) {
    margin-top: 3rem;
    margin-left: -0.5rem;
  }
`;

const Links = styled.div<{instanceAt?: string}>`
  display: flex;
  @media (min-width: ${({instanceAt})=>instanceAt == 'PostModule' ? '1326px' : '1023px'}) { 
    position: sticky;
    top: 12rem;
    flex-direction: column;
  }

  @media (max-width: 1317px) {
    margin-bottom: 3rem;
  }
`;

const SocialLink = styled(Link)`
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  line-height: 3rem;
  color: ${theme.colors.mediumBlue};
`;

const WhiteFacebookIcon = styled(FacebookIcon)`
  color: ${theme.colors.white};
`;

const WhiteIosShareIcon = styled(IosShareIcon)`
  color: ${theme.colors.white};
`;

const WhiteLinkedInIcon = styled(LinkedInIcon)`
  color: ${theme.colors.white};
`;

const WhiteTwitterIcon = styled(TwitterIcon)`
  color: ${theme.colors.white};
`;

function SocialShare({
  pathname,
  alignRight,
  darkBackground,
  instanceAt,
}: SocialShareProps) {
  const url = `https://www.ep.com${pathname}`;
  return (
    <Wrapper pathname={pathname} alignRight={alignRight}>
      <Links instanceAt={instanceAt}>
        <SocialLink
          to={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
          aria-label="Share on LinkedIn"
        >
          {darkBackground ? <WhiteLinkedInIcon /> : <LinkedInIcon />}
        </SocialLink>
        <SocialLink
          to={`http://www.twitter.com/intent/tweet?url=${url}`}
          aria-label="Share on Twitter"
        >
          {darkBackground ? <WhiteTwitterIcon /> : <TwitterIcon />}
        </SocialLink>
        <SocialLink
          to={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          aria-label="Share on Facebook"
        >
          {darkBackground ? <WhiteFacebookIcon /> : <FacebookIcon />}
        </SocialLink>
        <SocialLink
          to={`mailto:?subject=Check%20out%20this%20page%20at%20EP.com&body=Check%20out%20this%20page:%0D%0A%0D%0A${url}`}
          aria-label="Share through email"
          data-type="email"
        >
          {darkBackground ? <WhiteIosShareIcon /> : <IosShareIcon />}
        </SocialLink>
      </Links>
    </Wrapper>
  );
}

export default SocialShare;
